/**
 * ------------------------------------------------------------------------
 * Includes reusable variables and partials for styled-components
 * These styles mirror designs patterns from the pattern library
 * ------------------------------------------------------------------------
 */

import partials from './partials';
import vars from './vars';
import * as designToken from './DesignToken/variables';

export const theme = {
  vars,
  partials,
  designToken,
};

export type Theme = typeof theme;
